export default "__VITE_ASSET__kDaS64C1__"